import type { StatusLabelProps } from '@customerio/pluma-components/dist-react/components/label/label.utils';
import { Flex, InlineStack, Label, Spinner, Text, Tooltip } from '@customerio/pluma-components/react';
import type { ComputedStatus, StatusDetails } from '@/features/pipelines/utils';
interface StatusColorType {
  color: NonNullable<StatusLabelProps['color']>;
  label: string;
}

export const STATUS_OBJECTS: Record<ComputedStatus, StatusColorType> = {
  enabled: {
    color: 'green',
    label: 'Enabled',
  },
  disabled: {
    color: 'red',
    label: 'Disabled',
  },
  no_recent_data: {
    color: 'yellow',
    label: 'No recent data',
  },
  checking: {
    color: 'grey',
    label: 'Checking status',
  },
  failed: {
    color: 'grey',
    label: 'Pending',
  },
  disconnected: {
    color: 'grey',
    label: 'Disconnected',
  },
  needs_attention: {
    color: 'yellow',
    label: 'Needs attention',
  },
  oauth_disconnected: {
    color: 'yellow',
    label: 'Needs attention',
  },
};

type StatusDisplayProps = {
  isLoading: boolean;
  status?: StatusDetails;
  tooltip: (status: ComputedStatus, lastSeen?: number) => string;
};

export const StatusDisplay = ({ isLoading, status, tooltip }: StatusDisplayProps) => {
  const currentStatus = status ?? (isLoading ? { status: 'checking' } : { status: 'failed' });
  const statusTheming = STATUS_OBJECTS[currentStatus.status];
  return (
    <Flex gap="075" alignItems="center">
      {isLoading ? (
        <Spinner />
      ) : (
        <Tooltip content={tooltip(currentStatus.status, currentStatus.lastSeen)} placement="bottom">
          <Label color={statusTheming.color}>{statusTheming.label}</Label>
        </Tooltip>
      )}
    </Flex>
  );
};

type StatusBadgeProps = { status: ComputedStatus; plainLabel?: boolean };

export const StatusBadge = ({ status, plainLabel }: StatusBadgeProps) => {
  const isChecking = status === 'checking';
  const statusTheming = STATUS_OBJECTS[status];
  return isChecking ? (
    <InlineStack alignBlock="center" gap="200">
      <Spinner />
      <Text size="xs">checking…</Text>
    </InlineStack>
  ) : (
    <Label color={statusTheming.color} showStatusIndicator={plainLabel !== true}>
      {statusTheming.label}
    </Label>
  );
};
